import NodeMasterPage from '../../images/NodeMasterPage.png';

export default function NodeMaster() {
    return (
        <>
            <img src={NodeMasterPage} style={{ width: '100%' }} useMap="#imgmap2023814185039" alt="Node Master Image"/>
          
        </>
    );
}